import { render, staticRenderFns } from "./GridCompetenciesSelect.vue?vue&type=template&id=1fcbe050&scoped=true"
import script from "./GridCompetenciesSelect.vue?vue&type=script&lang=js"
export * from "./GridCompetenciesSelect.vue?vue&type=script&lang=js"
import style0 from "./GridCompetenciesSelect.vue?vue&type=style&index=0&id=1fcbe050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcbe050",
  null
  
)

export default component.exports